'use strict';

import Swal from 'sweetalert2';

import '@fify/form-bundle/styles/sweetalert2.scss';

const mixin = Swal.mixin({
    buttonsStyling:   false,
    showCancelButton: true,
    reverseButtons:   true,
    focusConfirm:     false,

    customClass: {
        popup:         'bg-light dark:bg-dark dark:text-dark-100 shadow-lg dark:shadow-dark-700',
        icon:          'text-yellow-500 dark:text-yellow-700',
        confirmButton: 'btn-primary',
        cancelButton:  'btn-cancel',
        denyButton:    'btn-delete',
    },

    showClass: {
        popup: 'swal2-show-fade-in',
    },

    hideClass: {
        popup: 'swal2-hide-fade-out',
    },

    // heroicon exclamation-circle outline
    iconHtml: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">'
                + '<path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />'
            + '</svg>',

    /**
     * @param {HTMLElement} popup
     */
    willOpen: function (popup) {
        const container = popup.parentNode.classList.contains('swal2-container') ? popup.parentNode : popup;

        // tell Turbo not to cache the popup
        container.dataset.turboTemporary = 'data-turbo-temporary';
    },
});

export default mixin;
